import React from 'react';
import PropTypes from 'prop-types';
import ShowMoreText from 'react-show-more-text';
import * as S from './styled';

const fn = () => null;
const TextMoreLess = ({ children, text = '', maxRows = 2, more, less, expanded, testId, onClick = fn }) => (
  <ShowMoreText
    lines={maxRows}
    expanded={expanded}
    more={more || <S.ShowMoreLess className="button-overflow-clamp">Show More</S.ShowMoreLess>}
    less={less || <S.ShowMoreLess className="button-overflow-clamp">Show Less</S.ShowMoreLess>}
    onClick={onClick}>
    {children ||
      (text ? (
        <S.Value className="text-overflow-clamp" data-testid={testId}>
          {text}
        </S.Value>
      ) : null)}
  </ShowMoreText>
);

TextMoreLess.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.string]),
  text: PropTypes.string,
  maxRows: PropTypes.number,
  more: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.string]),
  less: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.string]),
  expanded: PropTypes.bool,
  testId: PropTypes.string,
  onClick: PropTypes.func
};

export default TextMoreLess;
